import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { Bodytext, Footnote } from '@acorns/web-components'
import styled from 'styled-components'

import theme from 'theme'

type MenuItem = {
  icon: JSX.Element
  label: string
  subText?: string
  disabled?: boolean
  action: () => void
}

type Props = {
  menuItems: MenuItem[]
}

const Container = styled.ul`
  list-style-type: none;
  padding: 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: ${theme.borderRadius.large};
  border-color: ${theme.colors.ivory};
  border-width: 1px;
  border-style: solid;
  box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.05);

  & > :nth-child(n + 2) {
    border-top-color: ${theme.colors.ivory};
    border-top-width: 1px;
    border-top-style: solid;
  }
`

const Button = styled.button`
  display: flex;
  width: 100%;
  padding: 15px 18px;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  border: none;
  border-radius: ${theme.borderRadius.large};
  color: currentColor;
  cursor: pointer;
  background: none;
`

const IconContainer = styled.div`
  display: flex;
  align-items: flex-end;
`
const LabelContainer = styled.div`
  margin: 0 16px;
  align-self: center;
  margin-right: auto;
  max-width: 240px;
`

const StyledChevron = styled(AcornsIcon)`
  height: 12px;
  margin: 12px;
  flex-shrink: 0;
  margin-right: 0;

  path {
    fill: ${props => props.theme.colors.stoneLight};
  }
`

const MenuOption = styled.li`
  list-style-type: none;
  display: flex;
  position: relative;
  padding-right: 0px;
`

const Label = styled(Bodytext)`
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
`

const SubText = styled(Footnote)`
  line-height: 16px;
`

const FundingMenu = ({ menuItems }: Props) => (
  <Container data-testid={'menu'}>
    {menuItems.map(({ label, subText, action, icon, disabled }) => (
      <MenuOption key={label}>
        <Button data-testid={'menu-item'} key={label} onClick={action} disabled={disabled}>
          <IconContainer>{icon}</IconContainer>
          <LabelContainer>
            <Label>{label}</Label>
            {subText && <SubText>{subText}</SubText>}
          </LabelContainer>
          <StyledChevron icon={AcornsIcon.Icon.DisclosureRight} />
        </Button>
      </MenuOption>
    ))}
  </Container>
)
export { FundingMenu }
